import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { aboutimg, destination } from "../Constant/Index";
import { Link } from "react-router-dom";
import { contentApi } from "../network/Network";
import AgoraVideoCall from "../Components/AgoraVideoCall";

const AboutUs = () => {
	let currentUrl = window.location.href.split("/");
	const [getapi, setGetapi] = useState("");

	// how it work on
	useEffect(() => {
		contentApi(currentUrl[3])
			.then((res) => {
				setGetapi(res?.data);
			})
			.catch((err) => {});
	}, []);
	// ==================
	return (
		<>
			<Header />
			<PageHeader pagename="About Us" />
			<section className="meet-our-expert about-expert">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="solve-detail-img  radius-20 p-4">
								<div className="row align-items-center">
									<div className="col-lg-6 position-relative">
										<figure>
											<img
												src={getapi?.sectionOne?.image}
												className="img-fluid p-4"
												alt=""
											/>
										</figure>
									</div>
									<div className="col-lg-6">
										<div className="solved-heading pe-4">
											<h5 className="linear-bg-heading widht-wrapper mb-3 primary-regular-font">
												{getapi?.sectionOne?.top_heading}
											</h5>
											<h3 className="main-heading-font dark-color level-3 wow animate__ animate__zoomIn animated">
												{getapi?.sectionOne?.heading}
											</h3>
											<p
												className="primary-regular-font extra-color-5 level-7"
												dangerouslySetInnerHTML={{
													__html: getapi?.sectionOne?.paragraph,
												}}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="solved-sec about-solved pt-5 pb-4 ">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="row">
								<div className="col-lg-12">
									<h2 className="main-heading-font dark-color level-2 text-center wow animate__animated animate__zoomIn">
										{getapi?.sectionTwo?.heading}
									</h2>
									<div className="text-center pb-4">
										<p
											className="primary-regular-font extra-color-5 level-7"
											dangerouslySetInnerHTML={{
												__html: getapi?.sectionTwo?.paragraph,
											}}
										/>
									</div>
								</div>
							</div>
							<div className="solve-detail-img  radius-20 p-5">
								<div className="row align-items-center">
									<div className="col-lg-6 pe-5">
										<div className="solved-heading">
											<h5 className="extra-color-7 primary-medium-font level-6">
												{getapi?.sectionTwo?.paragraph_2}
											</h5>
											<h6 className="extra-color-7 primary-regular-font mb-3 mt-2 level-7">
												{getapi?.sectionTwo?.paragraph_3}
											</h6>
											<Link
												to="/about-us"
												className="btn log-in level-7 primary-regular-font text-decoration-none"
											>
												<span className="bg-wrapper">Read more</span>
											</Link>
										</div>
									</div>
									<div className="col-lg-6 wrapper-top-m">
										<figure>
											<img
												src={getapi?.sectionTwo?.image}
												className="img-fluid"
												alt=""
											/>
										</figure>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="our-mission-vision mb-5 pb-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="row">
								<div className="col-lg-6">
									<div className="our-content extra-bg-8 p-5 radius-20">
										<h3 className="main-heading-font dark-color ">
											{getapi?.sectionThree?.heading}
										</h3>
										<p
											className="extra-color-13 mt-3"
											dangerouslySetInnerHTML={{
												__html: getapi?.sectionThree?.paragraph,
											}}
										/>
									</div>
								</div>
								<div className="col-lg-6 wrapper-top-m">
									<div className="our-content extra-bg-8 p-5 radius-20">
										<h3 className="main-heading-font dark-color ">
											{getapi?.sectionFour?.heading}
										</h3>
										<p
											className="extra-color-13 mt-3"
											dangerouslySetInnerHTML={{
												__html: getapi?.sectionFour?.paragraph,
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <AgoraVideoCall /> */}
			<Footer />
		</>
	);
};

export default AboutUs;
